import * as Sentry from '@sentry/react';
import { env } from './env';

let sentryInitialized = false;

export function initSentry() {
  if (sentryInitialized || !env.sentryDsn) {
    if (!sentryInitialized && !env.sentryDsn) {
      // eslint-disable-next-line no-console
      console.info('[sentry] VITE_SENTRY_DSN missing; Sentry disabled');
    }
    return;
  }

  Sentry.init({
    dsn: env.sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });

  sentryInitialized = true;
}
